<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 style="color: #101010;line-height: 31px;" class="mb-0">
        {{ $l('form_header_userData') || '已授权用户' }}
      </h6>
      <el-button type="danger" size="mini" plain @click="clear()">
        {{ $l('btn_clear') || '清空授权' }}
      </el-button>
    </div>
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :roleID="roleID"
      @reload="reload"
    />
  </div>
</template>

<script>
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageMain },
  props: { roleID: { type: String, default: '' } },
  data() {
    return { tableData: [], loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .merchantRoleUserListApi({ roleID: this.roleID })
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []
      this.tableData = data.map((item) => {
        const { userName, userNameEn } = item
        return {
          ...item,
          displayUserName: [userNameEn, userName].filter(Boolean).join('-'),
        }
      })
    },
    reload() {
      this.getData()
      this.$emit('reload')
    },
    async clear() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_clear') || '是否清空该角色授权的所有用户？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .merchantRoleUserClearApi({ roleID: this.roleID })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_clear_no') || '清空失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_clear_ok') || '清空成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
